import axios from 'axios';

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 6000
});

export function getHome() {
  return http.get('/api/home').then(res => res.data);
}

export function getCurrentWeather(latitude, longitude) {
  return http.get('/api/weather', {
    params: { latitude, longitude }
  }).then(res => res.data);
}

export const defaultHome = {
  config: {
    siteName: 'menghuanchenfeng.cn',
    logoText: 'menghuanchenfeng.cn',
    avatarUrl: '/images/logo-avatar.png',
    backgroundUrl: '/images/home-bg.png',
    helloText: 'Hello World!',
    mainTitle: '一个建立于21世纪的小站，',
    highlightText: '专注于互联网的边缘',
    icpText: '苏ICP备2022018134号-1',
    copyrightText: 'Copyright © 2020 - 2026 & Made by menghuanchenfeng'
  },
  navMenus: [
    { name: '首页', icon: 'home', path: '/', target: '_self' },
    { name: '博客', icon: 'book-open', path: 'https://blog.example.com', target: '_blank' },
    { name: '工具页', icon: 'wrench', path: '/tools', target: '_self' },
    { name: '关于我', icon: 'user', path: '/about', target: '_self' }
  ],
  socialLinks: [
    { name: 'GitHub', icon: 'github', url: 'https://github.com/example' },
    { name: 'Bilibili', icon: 'tv', url: 'https://www.bilibili.com' },
    { name: 'QQ', icon: 'bell', url: 'https://im.qq.com' },
    { name: 'Email', icon: 'mail', url: 'mailto:hello@example.com' },
    { name: 'Twitter', icon: 'twitter', url: 'https://twitter.com' },
    { name: 'Telegram', icon: 'send', url: 'https://telegram.org' }
  ],
  quote: {
    content: '你是佳月亮的英雄。',
    source: '关于那些从未提起过的情书'
  },
  weather: {
    cityName: '南京',
    temperature: '23',
    weatherText: '多云转晴',
    airQuality: '优',
    tips: '夜晚微风，记得添件外套'
  },
  siteLinks: [
    { title: '博客', description: '记录与分享', icon: 'feather', url: 'https://blog.example.com', target: '_blank' },
    { title: '网址集', description: '收藏夹', icon: 'bookmark', url: '/links', target: '_self' },
    { title: '今日热榜', description: '发现热点', icon: 'flame', url: '/hot', target: '_self' },
    { title: '工具箱', description: '效率工具', icon: 'message-circle', url: 'https://tools.example.com', target: '_blank' }
  ],
  music: {
    config: {
      enabled: 0,
      autoplay: 0,
      mode: 'meting',
      metingApi: 'https://meting.mysqil.com/api?server=:server&type=:type&id=:id&auth=:auth&r=:r',
      metingId: '492088243',
      metingServer: 'netease',
      metingType: 'playlist',
      loopMode: 'list',
      volume: 60,
      playerPosition: 'right-bottom',
      showLyric: 0
    },
    tracks: []
  }
};
